import React from 'react';

function About1() {
  const isMobile = window.innerWidth < 768; // Check if the screen width is less than 768px

  return (
    <div>
      <div id="preloader-wrap">
        <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
          <path id="preloader-bg" d="M0,1005S175,995,500,995s500,5,500,5V0H0Z" />
        </svg>
        <div 
          className="site-preloader preloader-text" 
          style={{
            fontSize: isMobile ? '1.5rem' : '3rem', // Smaller font size for mobile
            textAlign: 'center',
          }}
        >
          <span data-text="t">t</span>
          <span data-text="i">i</span>
          <span data-text="t">t</span>
          <span data-text="a">a</span>
          <br /> {/* Line break after TITA */}
          <span data-text="t">t</span>
          <span data-text="e">e</span>
          <span data-text="c">c</span>
          <span data-text="h">h</span>
          <span data-text="n">n</span>
          <span data-text="o">o</span>
          <span data-text="l">l</span>
          <span data-text="o">o</span>
          <span data-text="g">g</span>
          <span data-text="i">i</span>
          <span data-text="e">e</span>
          <span data-text="s">s</span>
        </div>
      </div>
    </div>
  );
}

export default About1;